<template>
  <main>
    <section>
      <div class="align-content-center m-4">
        <div class="page_title" style="display: flex;justify-content: center;">
          <div>
            <h3 class="page_title" style="display: inline-block;
                  height: 4.1rem;
                  border-bottom: 3px solid rgb(252, 180, 46); color: rgb(252, 180, 46);">Favorite </h3>
          </div>

        </div>
      </div>
      <div style=" height: 30px;background-color: #2C2C2B;text-align: left;; line-height: 30px;">
        <div class="custom-header" style=" display: flex;text-align: center;">

        </div>
      </div>
    </section>
    <div>
      <table v-if="isHave">
        <tr>
          <td class=" col-md-1-1" style="vertical-align: top; padding: 0;background-color: #1D1D1B;">
            <div class="tree-box" style="width: 100%;min-width: 200px;">
              <!-- <div style=" height: 40px;background-color: #434343;text-align: center; line-height: 40px;">
                <div class="custom-header" style=" display: flex;text-align: center;">
                  <div style="position: relative;text-align: center;width: 100%;">
                    Annual
                  </div>
                 
                
                </div>
              </div> -->
              <div class="tree-content" style="margin-top: 20px;">
                <el-tree ref="treeleft" :data="yearData" node-key="id" :indent="0" class="tree-line"
                  :row-style="{'padding-top':'0px','padding-bottom':'0px',height:'30px','line-height':'30px'}"
                  :default-expand-all="true" :expand-on-click-node="false" @node-click="handleNodeClick">
                  <span slot-scope="{ data }" class="custom-tree-node">
                    <template>
                      <div class="node_div">
                        <span class="name-box">
                          {{ data.name }}<span v-if="data.itemNum>0" style="color: #F3AD2C;">({{data.itemNum}})</span>
                        </span>
                      </div>
                    </template>
                  </span>
                </el-tree>
              </div>
            </div>
          </td>
          <td class="container col-md-10-1"
            style="vertical-align: top;padding: 0;padding-left: 120px;padding-top: 30px;">
            <!-- <section class="row  col-md-12 text-left content_padding">
              <div class="mb-2 col-md-6">
                <h5 class="">The product you are interested in: </h5>
              </div>
            </section> -->
            <section data-aos="fade-left" v-for="item in favoriteList" :key="item.id">
              <div class="row" @click="navigateTo()"
                style="display: flex;align-items: center;padding: 1.2rem 0;border-bottom: 1px solid #F1F1F1;">
                <div class="col-md-2 content_padding pt-2 pb-2">
                  <div class=" overlay border-0">
                    <img class="card-img" :src="item.url" alt="Card image"
                      style="max-height: 8.5rem;max-width: 8.5rem;background: linear-gradient(to bottom right, #2C2C2C, #000000);">
                  </div>
                </div>
                <div class="col-md-7 content_padding pt-2 pb-2">
                  <div class="overlay  border-0 text-left pb-2">
                    <h5 class="card-title">{{item.name}}</h5>
                    <p class="card-text text-muted">
                      ITEMS：{{item.code}}
                    </p>
                    <p class="card-text text-muted">
                      TYPE：{{item.typeName}}
                    </p>
                  </div>
                </div>
                <div class="col-md-3 content_padding text-right">
                  <button class="control" @click="delFav(item)">×</button>
                </div>
              </div>
            </section>
            <section class="mt-5">
              <div>
                <button class="btn custom-btn-primary" style="margin-right: 15px;min-height: 2.4rem;min-width:  8rem;"
                  @click="sendMail">
                  <img src="/assets/img/VIP/Email.png" style="max-width: 1.2rem;margin: 0 0.2rem;">Send Email</button>
                <button class="btn " style="min-height: 2.4rem;min-width:  8rem;"><img src="/assets/img/VIP/btnHome.png"
                    style="max-width: 1.2rem;margin: 0 0.2rem;margin-bottom: 4px;">Home</button>
              </div>
            </section>
          </td>
        </tr>
      </table>
    </div>
  </main>
</template>

<script>
  import { getFavoriteList, getFavoriteTree, delFavoriteInfo,sendUpdate } from "@/api/rbac/product";
  import { sendMail } from "@/api/rbac/main";
  export default {
    name: 'Favorite',
    data() {
      return {
        isChecked: false,
        txtCheck: 'Favorite',
        favData: [{ id: 1, title: '39W Elliptical working light', items: 'SA6066-39', type: 'Work Light', img: require('../../../public/assets/img/VIP/Favorite1.png') },
        { id: 2, title: '12W Square working Light', items: 'SA6063-12', type: 'Work Light', img: require('../../../public/assets/img/VIP/Favorite2.png') },
        { id: 3, title: '48W Square working Light', items: 'SA6063-48', type: 'Work Light', img: require('../../../public/assets/img/VIP/Favorite3.png') },
        { id: 4, title: '4.9 Inch LED Strobe Lighthead', items: 'SA7032-18', type: 'Warning Light', img: require('../../../public/assets/img/VIP/Favorite4.png') },
        { id: 5, title: 'Work Light,20W,10-30V', items: 'SA6057', type: 'Work Light', img: require('../../../public/assets/img/VIP/Favorite5.png') },
        ],
        yearData: [],
        favoriteList: [],
        isHave: true,
      };
    },
    created() {
      this.getTreeData();
    },
    methods: {
      getTreeData() {
        getFavoriteTree({ strWhere: '' }).then(res => {
          if (res.data.length == 0) {
            this.yearData = [];
          }
          else {
            this.yearData = res.data;
            if (res.data[0].children.length == 0) {
              this.isHave = false
            }
          }
        })

        this.getFavoriteList("");
      },
      getFavoriteList(strWhere) {
        if (!this.$isDevelopment) {
          strWhere = ' and a.personID=' + this.user.id
        }
        // console.log('222',this.$store.state.user)
        // const storedUser = localStorage.getItem("token");
        // const user = JSON.parse(storedUser);
        // var params={strWhere:strWhere};
        // if (this.store.user.userName!='admin') {

        // }
        getFavoriteList({ strWhere: strWhere }).then(res => {
          if (res.data.length > 0) {
            this.favoriteList = res.data;
            this.favoriteList.forEach(element => {
              element.url = '../../../assets/img/ProductCover/' + element.url
            });
          }
          else {
            this.favoriteList = [];
          }
        })
      },
      handleNodeClick(node) {
        if (node.pID == 0) {
          this.getFavoriteList('')
        }
        else {
          this.getFavoriteList(` and YEAR(a.date)='${node.realID}'`)
        }
      },
      delFav(item) {
        delFavoriteInfo(item.id).then(res => {
          if (res.data != "ok") {
            return alert("Fail Delete")
          }
          else {
            this.getTreeData();
          }
        })
      },
      navigateTo() {
        this.$router.push(`${this.$route.path}/name`);
      },
      setDefaultNode(id) {
        // 假设你想默认聚焦的节点的 id 是 5
        this.$nextTick(() => {
          const tree = this.$refs.treeleft;
          const node = tree.getNode(id);
          if (node) {
            tree.setCurrentKey(id);
            //tree.setCurrentNode(node); // 可选，根据需求选择是否使用
          }
        });
      },
      sendMail() {
        try {
          let favCode = '';
          this.favoriteList.forEach(element => {
            favCode = favCode + element.code + '<br>'
          });
          const email = {
            toMail: 'contact@sanmak.com',
            // toMail: '2881252458@qq.com',
            body: `<head>
<meta charset='UTF-8'>
    <base target="_blank" />
    <style type="text/css">::-webkit-scrollbar{ display: none; }</style>
    <style id="cloudAttachStyle" type="text/css">#divNeteaseBigAttach, #divNeteaseBigAttach_bak{display:none;}</style>
    <style id="blockquoteStyle" type="text/css">blockquote{display:none;}</style>
    <style type="text/css">
        body{font-size:14px;font-family:arial,verdana,sans-serif;line-height:1.666;padding:0;margin:0;overflow:auto;white-space:normal;word-wrap:break-word;min-height:100px}
        td, input, button, select, body{font-family:Helvetica, 'Microsoft demo', verdana}
        pre {white-space:pre-wrap;white-space:-moz-pre-wrap;white-space:-pre-wrap;white-space:-o-pre-wrap;word-wrap:break-word;width:95%}
        th,td{font-family:arial,verdana,sans-serif;line-height:1.666}
        img{ border:0}
        header,footer,section,aside,article,nav,hgroup,figure,figcaption{display:block}
        blockquote{margin-right:0px}
        </style>
    </head>
    <body tabindex="0" role="listitem">
    <table width="700" border="0" align="center" cellspacing="0" style="width:700px;">
        <tbody>
        <tr>
            <td>
                <div style="width:700px;margin:0 auto;border-bottom:1px solid #ccc;margin-bottom:30px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="700" height="39" style="font:12px Tahoma, Arial, 宋体;">
                        <tbody><tr><td width="210"></td></tr></tbody>
                    </table>
                </div>
                <div style="width:680px;padding:0 10px;margin:0 auto;">
                    <div style="line-height:1.5;font-size:20px;margin-bottom:25px;color:#4d4d4d;">
                        <strong style="display:block;margin-bottom:20px;">Dear SANMAK：</strong>
                        <strong style="display:block;margin-bottom:20px;">
                           I would like to know about the following products of your company:
                        </strong>
                    </div>
                   <div style="margin-bottom:30px;">
                        <small style="display:block;margin-bottom:20px;font-size:15px;">
                            <p style="color:#747474;">
                               ${favCode}
                            </p>
                        </small>
                    </div>
                </div>
                <div style="width:700px;margin:0 auto;">
                    <div style="padding:10px 10px 0;border-top:1px solid #ccc;color:#747474;margin-bottom:20px;line-height:1.3em;font-size:15px;">
                        <strong style="display:block;margin-bottom:20px;">
                           FROM:${this.user==null?'admin':this.user.code}
                        </strong>
                    </div>
                </div>
            </td>
        </tr>
        </tbody>
    </table>
    </body>`,
            subject: this.user==null?'admin':this.user.code
          }
          sendMail(email).then((res) => {
            if (res.data == 'ok') {
              alert("The email has been sent. Please wait for us to contact you.")
              sendUpdate(this.user==null?1:this.user.id)
            }
            else {
              alert("The email sending failed.")
            }
          });
        } catch (error) {
          console.log(error);
        }
      },
    },
    mounted() {
      // this.setDefaultNode(4);
    },
    computed: {
      user() {
        if (this.$store.state.user == null) {
          var storUser = localStorage.getItem("token")
          if (storUser == null) {
            return this.$store.state.user
          }
          else {
            var thisuser = JSON.parse(storUser);
            return thisuser
          }

        }
        else {
          return this.$store.state.user
        }
        // 使用计算属性来获取用户信息，这样当用户信息变化时，界面也会自动更新
      },
    },
  };
</script>

<style scoped>
  @import '../../assets/css/main.css';

  .tree-line {
    background-color: transparent;
    color: #D3D3D2;
  }

  /* ::v-deep .el-tree-node.is-current  > .el-tree-node__content {
  background: #FCB42E !important;
} */
  :deep(.control) {
    font-size: 20px;
    background: #707070;
    color: #fff;
    border: none;
    cursor: pointer;
    padding: 0px 10px;
    border-radius: 50%;
    z-index: 20;
  }

  .custom-checkbox {
    display: none;
    /* 隐藏原生的checkbox */
  }

  .custom-checkbox+label svg circle {
    transition: fill 0.2s, stroke 0.2s;
    /* 平滑过渡效果 */
  }

  .custom-checkbox:checked+label svg circle {
    fill: #FCB42E;
    /* 选中时的填充颜色 */
  }
</style>